import { render, staticRenderFns } from "./DiseaseEdit.vue?vue&type=template&id=1defadb9&scoped=true&"
import script from "./DiseaseEdit.vue?vue&type=script&lang=js&"
export * from "./DiseaseEdit.vue?vue&type=script&lang=js&"
import style0 from "./DiseaseEdit.vue?vue&type=style&index=0&id=1defadb9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1defadb9",
  null
  
)

export default component.exports